module.exports = __webpack_public_path__ + "assets/81ea68f3ec9a8a1589a6f4680d4aefd2.png";